/**
 * @file   src\store\slices\settingsSlice.ts
 * @brief  This file is responsible for creating settings based slices to call actions and state management.
 * @date   JuLY, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { createSlice } from '@reduxjs/toolkit';
import { ISettingsState } from '../../interfaces/settingsInterface';
import { getCompanySettings } from '../actions/settingsAction';

// Initial state
const settingsDefaultState: ISettingsState = {
  isGetSettingsLoading: false,
  isGetSettingsSuccess: false,
  getSettingsErrorCode: 0,
  getSettingsErrorMessage: null,
  getSettings: {},
};

// Settings slice
const settingsSlice = createSlice({
  name: 'settings',
  initialState: settingsDefaultState,
  reducers: {
    resetSettings: (state) => {
      state.isGetSettingsLoading = false;
      state.isGetSettingsSuccess = false;
      state.getSettings = {};
      state.getSettingsErrorCode = 0;
      state.getSettingsErrorMessage = '';
      
    },
  },
  extraReducers(builder) {
    // get company settings api starts.
    builder.addCase(getCompanySettings.pending, (state) => {
      state.isGetSettingsLoading = true;
      state.isGetSettingsSuccess = false;
      state.getSettings = {};
      state.getSettingsErrorCode = 0;
      state.getSettingsErrorMessage = '';
      
    });
    // get company settings api success
    builder.addCase(getCompanySettings.fulfilled, (state, action) => {
      const error = action.payload?.error || 0;
      const data = action.payload?.data || {};
      state.isGetSettingsLoading = false;
      state.isGetSettingsSuccess = true;
      state.getSettings = data || {};
      state.getSettingsErrorCode = error;
      state.getSettingsErrorMessage =  error.message ;
    });
    // get company settings api failure
    builder.addCase(getCompanySettings.rejected, (state, action: any) => {
      const error = action.payload?.error || 0;
      state.isGetSettingsLoading = false;
      state.isGetSettingsSuccess = false;
      state.getSettingsErrorCode = error;
      state.getSettingsErrorMessage = error.message;
    });

  },
});
// Export actions
export const { resetSettings } = settingsSlice.actions;
// Export reducer.
export default settingsSlice.reducer;
